<template>
  <v-card class="mx-auto" flat>
    <v-container>
      <div class="pa-5">
        <base-form-generator :schema="schema" v-model="form" />
      </div>
    </v-container>
  </v-card>
</template>

<script>
import BaseFormGenerator from '@components/base/BaseFormGenerator';
import SchemaBiodata from '../schema/administrasi';

export default {
  name: 'FormAdministrasi',
  components: { BaseFormGenerator },
  mixins: [SchemaBiodata],
  props: {
    masters: {
      type: Object,
      default: () => {},
    },
    initValue: {
      type: Object,
      default: () => null,
    },
  },
  data() {
    return {
      form: {},
    };
  },
  methods: {
    reset() {
      this.$set(this, 'form', {});
    },

    initForm(value) {
      const profil = [...this.schema];
      for (const item of profil) {
        if (item.name) {
          this.$set(this.form, item.name, this.$getDeepObj(value, item.name) || '');
        }
      }
    },

    getValue() {
      let values = Object.assign({}, this.form);

      if (+this.form.k_pegawai_psp !== 50001) {
        values['k_golongan'] = '';
        values['nip'] = '';
      }

      return values;
    },
  },
  watch: {
    initValue: 'initForm',
  },
};
</script>

<style scoped></style>
